var map = {
	"./калькулятор.webp": 434,
	"./комиссия.webp": 497,
	"./контакты.webp": 427,
	"./корзина.webp": 704,
	"./мотосервис.webp": 308,
	"./оплата.webp": 449,
	"./преимущества.webp": 42,
	"./созвонимся.webp": 411,
	"./статистика.webp": 198,
	"./торги.webp": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;